import { DemandSales, DemandSalesTable, DemandSalesResponse } from "@/features/home/types";

export const processDemandSales = (
  data: DemandSalesResponse,
  ommitSize: number,
  summarizedVendorName: string
): { chart: DemandSales; table: DemandSalesTable[] } => {
  const processedChart = {
    labels: [],
    revenue: [],
    revenueBreakdown: [],
  } as DemandSales;

  let processedTable = [] as DemandSalesTable[];

  const tmp = data.demandSales.sort((a, b) => b.revenue - a.revenue);
  if (data.demandSales.length < ommitSize) {
    processedTable = tmp;
    tmp.forEach(demandSale => {
      processedChart.labels.push(demandSale.vendor);
      processedChart.revenue.push(Math.floor(demandSale.revenue));
      processedChart.revenueBreakdown.push(demandSale.revenueBreakdown);
    });
    return { chart: processedChart, table: processedTable };
  } else {
    let tmpRevenue = 0 as number;
    let tmpRevenueBreakdown = 0 as number;
    tmp.forEach((demandSale, index) => {
      if (index < ommitSize - 1) {
        processedTable.push(demandSale);
        processedChart.labels.push(demandSale.vendor);
        processedChart.revenue.push(Math.floor(demandSale.revenue));
        processedChart.revenueBreakdown.push(demandSale.revenueBreakdown);
      } else {
        tmpRevenue += demandSale.revenue;
        tmpRevenueBreakdown += demandSale.revenueBreakdown;
      }
    });
    const tmpDemand = {
      vendor: summarizedVendorName,
      revenue: Math.floor(tmpRevenue),
      revenueBreakdown: tmpRevenueBreakdown,
    };
    processedTable.push(tmpDemand);
    processedChart.labels.push(tmpDemand.vendor);
    processedChart.revenue.push(tmpDemand.revenue);
    processedChart.revenueBreakdown.push(tmpDemand.revenueBreakdown);

    return { chart: processedChart, table: processedTable };
  }
};
